/**
 * Dedicated subclasses of the theme's <drawer-content>/<popover-content> used for the metafield-driven
 * "How to Measure" / size chart content (product.metafields.accentuate.content). Content is fetched on
 * demand via the `href` attribute (see snippets/product-form.liquid) instead of being rendered inline on
 * every PDP load — OpenableElement._load() only fetches when `href` is present, and only once per instance.
 *
 * Loaded conditionally — only when a product actually has size-guide content configured (see the
 * `found_size_option_metafield` guard in snippets/product-form.liquid) — instead of living in the
 * sitewide custom.js bundle, since <size-guide-drawer>/<size-guide-popover> only ever appear on PDPs
 * that use this feature.
 */
(function () {
  if (!window.customElements.get('size-guide-drawer')) {
    class SizeGuideDrawer extends DrawerContent {}
    window.customElements.define('size-guide-drawer', SizeGuideDrawer);
  }

  if (!window.customElements.get('size-guide-popover')) {
    class SizeGuidePopover extends PopoverContent {}
    window.customElements.define('size-guide-popover', SizeGuidePopover);
  }
})();
